import { useIdleTimer } from "react-idle-timer";
import config from "../config";
import { setShowIdlePopup } from "../dispatchers/appDispatchers";

const useIdleTimeout = () => {
  const idleTimeInMinutes = Number(config.idleTime);
  const idleTimeout = idleTimeInMinutes * 60 * 1000;
  
  const idleTimer = useIdleTimer({
    timeout: idleTimeout,
    onIdle: () => {
      setShowIdlePopup(true);
    },
    debounce: 500,
  });

  return { idleTimer };
};

export default useIdleTimeout;
